import { useTickSoundInteraction } from "@/hooks";
import { formatAmount } from "@/utils/parking";

interface KeyValueRowProps {
    label: string;
    value: string | React.ReactNode;
    className?: string;
    labelClassName?: string;
    valueClassName?: string;
    amount?: number;
    tabIndex?: number;
    ariaLabel?: string;
}

export default function KeyValueRow({
    label,
    value,
    className = "",
    labelClassName = "",
    valueClassName = "",
    amount = 0,
    tabIndex,
    ariaLabel,
}: KeyValueRowProps) {
    const { playTick } = useTickSoundInteraction();
    return (
        <div onKeyDown={(e) => {
            if (e.key === 'Enter') {
                playTick();
                e.preventDefault();
                e.stopPropagation();
            }
        }} tabIndex={tabIndex} data-interactive aria-label={`${label}: ${ariaLabel ? ariaLabel : value}`} className={`widescreen:w-[calc(638*var(--vw-unit))] flex w-[calc(712*var(--vw-unit))] items-center justify-between gap-[calc(16*var(--vw-unit))] focus-border  ${className}`}>
            <div className={`text-[calc(24*var(--vh-unit))] leading-[calc(44*var(--vh-unit))] text-[var(--color-text-sub01)] ${labelClassName || 'font-medium'}`}>
                {label}
            </div>
            <div className={`text-[calc(24*var(--vh-unit))] leading-[calc(44*var(--vh-unit))] text-[var(--color-text-sub01)] ${valueClassName || 'font-medium'}`}>
                <span className="number">{value}</span>{amount > 0 ? <><span className="number">{formatAmount(amount.toString())}</span><span>원</span></> : ''}
            </div>
        </div>
    );
}
